import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';

const useChatInboxSharedState = createGlobalState(() => {
  const currentChatId = ref(null);
  const unreadChatIds = ref([]);

  return {
    currentChatId,
    unreadChatIds,
  };
});

export default useChatInboxSharedState;
